function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M44 3.78v24M100 3.78v24"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 19.78,
  width: 136,
  height: 136,
  rx: 12,
  ry: 12
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M137.37 51.78H6.87M48.68 99.14a20.38 20.38 0 013.82-.36c9.66 0 17.5 6.72 17.5 15s-7.84 16-17.5 16a16.35 16.35 0 01-14.5-8M38 79.78h30L48.63 99.15M88 87.78l16-10v52"
});

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 144 159.78",
    "aria-hidden": true
  }, props), _ref, _ref2, _ref3);
};

export default SvgCalendar;